import { Button } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

const MedicationWaiverConsent = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => (
  <div className="flex flex-col justify-center">
    <Button onClick={() => setQuestionAnswer(true)} />
  </div>
);

export { MedicationWaiverConsent };
